import { Component } from '@angular/core';

import { Filters } from 'src/app/models/filters.model';
import { Router, ActivatedRoute } from '@angular/router';
import { SearcherService } from 'src/app/services/searcher.service';
import { concatMap, tap, shareReplay, catchError, finalize } from 'rxjs/operators';
import { BehaviorSubject, Observable } from 'rxjs';
import { EventsService } from 'src/app/services/events.service';
import { Environment } from 'src/environments/environment';

@Component({
  selector: 'page-full-screen-wall',
  templateUrl: 'full-screen-wall.html',
  styleUrls: ['full-screen-wall.scss']
})
export class FullScreenWallPage {
  public itemType: string = 'wall';
  public filters$: BehaviorSubject<Filters> = new BehaviorSubject({
    searchKey: '',
    start: 0,
    length: 20,
    orderBy: 'publishDate',
    orderDir: 'desc'
  });

  public componentId: number;
  public component$: Observable<any>;
  /** Keeps toolbar + item-searcher mounted on back navigation until component$ emits again */
  public latestComponent: any = null;

  private $event;
  public forbidden: boolean = false;
  public listLoading = true;
  public readonly listSkeletonPlaceholders = [1, 2, 3];

  constructor(private route: ActivatedRoute, private searcherService: SearcherService, private events: EventsService) {}

  ionViewWillEnter() {
    this.listLoading = true;

    const nextId = +this.route.snapshot.paramMap.get('id');
    if (this.componentId !== undefined && nextId !== this.componentId) {
      this.latestComponent = null;
    }
    this.componentId = nextId;

    const endpoint: string = `${Environment.API_BASE_URL_V2}/api/empatica/v1/components/wall/${this.componentId}/elements`;

    this.component$ = this.filters$.pipe(
      concatMap((filters) =>
        this.searcherService.allItems(endpoint, filters, this.itemType).pipe(finalize(() => (this.listLoading = false)))
      ),
      tap(() => this.$event && this.$event.target.complete && this.$event.target.complete()),
      tap((response) => {
        this.latestComponent = response;
      }),
      tap((response) => this.events.pages$$.next(response.title)),
      tap(() => (this.forbidden = false)),
      catchError((err: any) => {
        if (err.status === 403) {
          this.forbidden = true;
        }

        throw err;
      }),
      shareReplay()
    );

    this.getAllItems({ filters: { ...this.filters$.value, start: 0 } });
  }

  public getAllItems({ filters, event = null }) {
    if (event) this.$event = event;
    this.filters$.next(filters);
  }

  public refresh() {
    this.getAllItems({ filters: { ...this.filters$.value, start: 0 } });
  }
}
